import { IApplicationState } from '../../types/redux';

export const selectIsStickyButtonShown = (state: IApplicationState) => {
  return state.stickyButton;
};
